import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { spaceAndCapitalize, adminUser, managerUser } from '../../utilities/Forms.js'
import ModalContainerTrigger from '../../components/shared/ModalContainerTrigger'
import { request, handleRequestErrors } from '../../helpers/Requests'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class TidyUp extends Component {

  constructor(props) {
    super(props);

    this.handleRecordTabChange = this.handleRecordTabChange.bind(this);
    this.handleStatusTabChange = this.handleStatusTabChange.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.fetchDeletionImplications = this.fetchDeletionImplications.bind(this);
    this.requestDeletion = this.requestDeletion.bind(this);
    this.removeDeletion = this.removeDeletion.bind(this);
    this.handleDeletionConfirmation = this.handleDeletionConfirmation.bind(this);
    this.handleRemoveDeletionConfirmation = this.handleRemoveDeletionConfirmation.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.indexToRecordClassMap = this.setRecordClassMap();
  }

  state = {
    staff: [],

    recordTabIndex: 0,
    statusTabIndex: 0,

    recordClass: this.setRecordClassMap()[0],

    modalState: null,
    id: null,
    deletion_implications: {},

    loaded: false,
    loading: false,
    unauthorized: "",
    error: "",
    errors: ""
  };

  setRecordClassMap() {
    if (adminUser()) {
      return {
        0: "Location",
        1: "Device",
        2: "Import",
        3: "Person"
      }
    } else if (managerUser()) {
      return {
        0: "Person",
      }
    }
  }

  handleRecordTabChange(index) {
    const recordClass = this.indexToRecordClassMap[index];

    this.setState({
      recordTabIndex: index,
      recordClass: recordClass,
      deletion_implications: {}
    });

    this.fetchData(recordClass)
  }

  handleStatusTabChange(index) {
    this.setState({ statusTabIndex: index });
  }

  fetchData(recordClass) {
    this.setState({ loaded: false });

    let params = `delete[record_class]=${recordClass}`

    request("GET", `/v1/a/deletion_requests?${params}`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ records: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }

  fetchDeletionImplications(id) {
    request("GET", `/v1/a/deletion_requests/implications?delete[record_class]=${this.state.recordClass}&delete[record_id]=${id}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState(prevState => ({
          deletion_implications: {...prevState.deletion_implications, [id]: data}
        }))
      })
      .catch(error => {
        handleRequestErrors(this, error, { updating: false })
      })
  }

  requestDeletion(event) {
    const id = event.currentTarget.id;

    this.setState({
      modalState: "deletion_confirmation",
      id: id
    })

    if (!this.state.deletion_implications[id]) {
      this.fetchDeletionImplications(id)
    }
  }

  removeDeletion(event) {
    this.setState({
      modalState: "remove_deletion_confirmation",
      id: event.currentTarget.id
    })
  }

  handleDeletionConfirmation(event) {
    this.setState({ loading: true })

    let params = `delete[record_class]=${this.state.recordClass}&delete[record_id]=${this.state.id}`

    request("POST", `/v1/a/deletion_requests?${params}`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({
          modalState: null,
          id: null,
          loading: false
        })
        this.fetchData(this.state.recordClass)

        sessionStorage.setItem("updateSuccess", "Deletion Request created succesfully!");
        this.props.updatePopupCallback(Math.random())
      })
      .catch(error => handleRequestErrors(this, error, { loading: false }))
  }

  handleRemoveDeletionConfirmation(event) {
    this.setState({ loading: true })
    const id = this.state.records.find(record => record.id.toString() === this.state.id).deletion_request_id

    request("DELETE", `/v1/a/deletion_requests/${id}`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({
          modalState: null,
          id: null,
          loading: false
        })
        this.fetchData(this.state.recordClass)

        sessionStorage.setItem("updateSuccess", "Deletion Request removed succesfully!");
        this.props.updatePopupCallback(Math.random())
      })
      .catch(error => handleRequestErrors(this, error, { loading: false }))
  }

  closeModal() {
    this.setState({
      modalState: null,
      id: null
    })
  }

  renderError() {
    if (this.state.error.length > 0) {
      return (
        <div className="errors">{this.state.error}</div>
      )
    }
  }

  renderDeletionImplications(id) {
    const deletion_implications = this.state.deletion_implications[id];
    const errors = this.state.errors

    if (errors) {
      return (
        <div>
          {errors["errors"].map((errors, index) => (
            <div className="warning-box" key={index}>{errors}</div>
          ))}
        </div>
      )
    }

    if (!deletion_implications) {
      return <div>Loading a list of dependant records which would be deleted alongside this record...</div>
    }

    return (
      <div>
        {Object.keys(deletion_implications).map(key => (
          <div key={key}>{spaceAndCapitalize(key)} - {deletion_implications[key]}</div>
        ))}
      </div>
    )
  }

  render() {
    const { id, records, deletion_implications, statusTabIndex, recordTabIndex, modalState, loaded, loading, unauthorized, error, errors } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const activeRecords = records.filter(record => record.deletion_request_id === null)
      return (
        <div>
          <div>
            <div className="top-text">
              <p>This is the Data Tidy Up page. Here you can see a list of records which can be deleted and see records already marked for deletion.</p>
              <p>You can choose to request deletion of records you no longer need. After a 2 week cool-off period, the record and all other records dependant on it will be deleted if that request has not been removed.</p>
            </div>
          </div>

          <br/>

          <Tabs selectedIndex={recordTabIndex} onSelect={value => this.handleRecordTabChange(value)} className="big-tabs">
            <TabList>
              {Object.entries(this.indexToRecordClassMap).map(([index, label]) => (
                label === "Person" ? (
                  <Tab key={index}>People</Tab>
                ) : (
                  <Tab key={index}>{label}s</Tab>
                )
              ))}
            </TabList>

            <TabPanel/>
          </Tabs>

          <Tabs selectedIndex={statusTabIndex} onSelect={value => this.handleStatusTabChange(value)} className="small-tabs">
            <TabList>
              <Tab key={0}>Active</Tab>
              <Tab key={1}>Marked for deletion</Tab>
            </TabList>
            <TabPanel key={0}>
              <div className="table big-table">
                <div className="tr heading">
                  <div className="th">Name</div>
                  <div className="th">Request Deletion</div>
                </div>

                {activeRecords.map((record) => (
                  <div key={record.id} id={record.id} className="tr">
                    <div className="td">{record.name}</div>
                    <div className="td center"><div className="small button" id={record.id} onClick={this.requestDeletion}>Request Deletion</div></div>
                  </div>
                ))}
              </div>

              {this.indexToRecordClassMap[recordTabIndex] === "Person" && (
                <div className="long-tr">
                  <div className="long-td">
                    There are too many People in the system to display them here. Please go to the People page to mark a person for deletion.
                    <br/><br/>
                    Existing Deletion Requests can be seen on the "Marked for deletion" tab above.
                  </div>
                </div>
              )}

              {activeRecords.length === 0 && this.indexToRecordClassMap[recordTabIndex] !== "Person" && (
                <div className="long-tr">
                  <div className="long-td">
                    No records found.
                  </div>
                </div>
              )}
            </TabPanel>

            <TabPanel key={1}>
              <div className="table big-table">
                <div className="tr heading">
                  <div className="th">Name</div>
                  <div className="th">Deletion Time</div>
                  <div className="th">Requested By</div>
                  <div className="th">View Dependant Records</div>
                  <div className="th">Remove Deletion Request</div>
                </div>
                {records.filter(record => record.deletion_time !== null).map((record) => (
                  <div key={record.id} id={record.id} className="tr">
                    <div className="td">{record.name}</div>
                    <div className="td center">{record.deletion_time}</div>
                    {record.admin_name ? (
                      <div className="td center">{record.admin_name}</div>
                    ) : (
                      <div className="td center"><Link className="visible-link" to={`/settings/users/${record.user_id}`}>{record.user_name}</Link></div>
                    )}
                    <div className="td center">
                      {deletion_implications[record.id] || errors ?
                        this.renderDeletionImplications(record.id) :
                        <div className="link" id={record.id} onClick={() => this.fetchDeletionImplications(record.id)}>View Dependants</div>
                      }
                    </div>
                    <div className="td center"><div className="small button red-button" id={record.id} onClick={this.removeDeletion}>Remove Deletion Request</div></div>
                  </div>
                ))}
              </div>
              {records.length === 0 && (
                <div className="long-tr">
                  <div className="long-td">
                    No records found.
                  </div>
                </div>
              )}
            </TabPanel>
          </Tabs>

          <ModalContainerTrigger showModal={modalState === "deletion_confirmation"} closeModal={this.closeModal} closeName="Cancel">
            <div className="modal-title">Deletion Confirmation Window</div>

            <div className="bottom-padding"><strong>Name:</strong> {records.find(record => record.id.toString() === id)?.name}</div>

            {this.renderDeletionImplications(id)}

            <div className="top-padding">Are you sure you wish to request deletion of all these records?</div>

            <div className="center-two-buttons">
              <button className="small button small-top-padding" value="ok" onClick={this.handleDeletionConfirmation} disabled={loading}>Yes, I wish to delete all of these records</button>
            </div>
          </ModalContainerTrigger>

          <ModalContainerTrigger showModal={modalState === "remove_deletion_confirmation"} closeModal={this.closeModal} closeName="Cancel">
            <div className="modal-title">Deletion Information for {records.find(record => record.id.toString() === id)?.name}</div>

            <div className="small-top-padding center">Are you sure you wish to remove this deletion request?</div>

            <div className="center-two-buttons">
              <button className="small button small-top-padding" value="ok" onClick={this.handleRemoveDeletionConfirmation} disabled={loading}>Yes, remove this deletion request and restore any dependant records</button>
            </div>
          </ModalContainerTrigger>

          {this.renderError()}
        </div>
      )
    }
  }

  componentDidMount() {
    this.fetchData(this.state.recordClass)
  }
}

export default TidyUp;
